export default __webpack_public_path__ + "static/media/commentIcon.7526431d.svg";